import axios, { AxiosRequestConfig } from 'axios';
import { getToken } from '../helpers/Token';
import modsfactoryUrls from "../configs/mods_factory/modsfactoryUrls";

const onRequest = (config: AxiosRequestConfig): AxiosRequestConfig => {
  config.headers ||= {};
  config.headers['Content-Type'] = 'application/json';
  config.headers['Authorization'] = `Bearer ${getToken()}`;

  return config;
}

const modsFactoryApi = axios.create({ baseURL: modsfactoryUrls.baseURL });
modsFactoryApi.interceptors.request.use(onRequest);

export default modsFactoryApi;
